import { Component, type ReactNode } from 'react';
import { useAppStore } from '../store.js';

/** Must be bundled with the entry, so a failed lazy chunk cannot hide recovery controls. */
export class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };
  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }
  override render() {
    if (!this.state.failed) return this.props.children;
    const receipt = /\/result\/?$/.test(window.location.pathname)
      ? useAppStore.getState().lastResult
      : null;
    const result = receipt && Number.isFinite(receipt.score) ? receipt : null;
    return (
      <main
        className="screen centered"
        role="alert"
        style={{ minHeight: '100dvh', padding: 24, gap: 16, textAlign: 'center' }}
      >
        <h1>{result ? 'Результат сохранён' : 'Не удалось открыть экран'}</h1>
        {result ? (
          <p style={{ fontSize: 32, fontWeight: 800 }}>
            {result.score.toLocaleString('ru-RU')} очков
          </p>
        ) : null}
        <p>Не удалось загрузить интерфейс. Обновите экран — списаний не будет.</p>
        <button className="primary-button" onClick={() => window.location.reload()}>
          Обновить экран
        </button>
      </main>
    );
  }
}
